import APICaller, { POST } from "../apiCaller";
import BrowserURLs from "./urls";

function getRedditTrending(filters) {
  return APICaller(POST, BrowserURLs.getRedditStocks, filters);
}
function getTwitterTrending(filters) {
  return APICaller(POST, BrowserURLs.getTwitterStocks, filters);
}
function getAllTrending(filters) {
  return APICaller(POST, BrowserURLs.getAllStocks, filters);
}
function getPennystocksTrending(filters) {
  return APICaller(POST, BrowserURLs.getPennystocks, filters);
}
const BrowserService = {
  getTwitterTrending,
  getRedditTrending,
  getAllTrending,
  getPennystocksTrending
};

export default BrowserService;
